<sim-basic-material-dialog
	(closeClicked)="close()"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-layer-plus'}"
	[headerText]="(isSubgroup() ? T.NEW_SUBGROUP_DIALOG_HEADER : T.NEW_GROUP_DIALOG_HEADER) | translate"
>
	<ng-container dialogContent>
		<form>
			<!--NAME-->
			<mat-form-field color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-pen" fontSet="fas" inline />
					{{ T.LABEL_NAME | translate }}
				</mat-label>
				<input [formControl]="form.controls.name" matInput type="text" />
				<mat-error>{{ T.ERROR_REQUIRED | translate }}</mat-error>
			</mat-form-field>

			<!--COLOR-->
			<sim-color-select [formCtrl]="form.controls.color" />

			<button #submit type="submit" hidden (click)="doSubmit()"></button>
		</form>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="submit.click()"
			[appBusy]="busy()"
			[icon]="{fontSet: 'far', fontIcon: editGroup() ? 'fa-check' : 'fa-plus'}"
			[label]="editGroup() ? T.BUTTON_SAVE : T.BUTTON_CREATE"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
